import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/arrow_up_black_icon.png'
import _imports_1 from '@/assets/arrow_down_gray_icon.png'


const _withScopeId = n => (_pushScopeId("data-v-60fe825c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "footer-wrap"
}
const _hoisted_2 = { class: "footer-type" }
const _hoisted_3 = {
  key: 0,
  src: _imports_0,
  alt: "Company Info close"
}
const _hoisted_4 = {
  key: 1,
  src: _imports_1,
  alt: "Company Info open"
}
const _hoisted_5 = { class: "footer-content" }
const _hoisted_6 = {
  key: 0,
  class: "footer-content2"
}
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "footer-copyright" }
const _hoisted_10 = ["textContent"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return ($setup.route.path !== '/scan/receiptscanner')
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.viewControl(1)))
          }, [
            _createElementVNode("span", {
              class: _normalizeClass({ 'active-color-black': $setup.footerType === 1 })
            }, "Company Info", 2),
            ($setup.footerType === 1)
              ? (_openBlock(), _createElementBlock("img", _hoisted_3))
              : (_openBlock(), _createElementBlock("img", _hoisted_4))
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          ($setup.footerType === 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _createTextVNode(" Global Tax Free Co.,Ltd."),
                _hoisted_7,
                _createTextVNode("9fl, 131, Toegye-ro, Jung-gu, Seoul, Republic of Korea"),
                _hoisted_8,
                _createTextVNode("+82-02-518-0837, gtf@global-taxfree.com ")
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_9, "Copyright " + _toDisplayString(new Date().getFullYear()) + " Global Tax Free Co.,Ltd.", 1),
        ($setup.clientType !== 'PRD')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              class: "footer-client-type",
              textContent: _toDisplayString($setup.clientType)
            }, null, 8, _hoisted_10))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}